import React from 'react';
import ReactDOM from 'react-dom';

import Plinko from './components/Plinko/Plinko';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Plinko />
  </React.StrictMode>,
  document.getElementById('root')
);